// extracted by mini-css-extract-plugin
export default {"firstContent":"styles_firstContent__ZEUlC"};